import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';

function UMODetailViewFullImage({ isFullImageShown, onFullImageToggle, umoData }) {
  if (!umoData || !umoData.fullSrc || !umoData.type) {
    return null;
  }
  const host = umoData.fullSrc.includes('/wds/') ?
      appConfig.cardURL : appConfig.hostURL;
  let img = '';

  if (umoData.type === 'PHOTO') {
    img = appConfig.useZoomify ?
        (<iframe
          className="umo-grid-item__fullscreen-zoomify-display"
          src={appConfig.hostURL + umoData.zoomifyURL}
        />) :
        (<img
          className="umo-grid-item__fullscreen-image-display"
          alt=""
          src={umoData.fullSrc}
          onContextMenu={disableRightClick}
        />);
  } else {
    img = (<iframe
      className="umo-media-view__html"
      src={host + umoData.fullSrc}
      onContextMenu={disableRightClick}
    />);
  }
  return (
    <div className="umo-grid-item__fullscreen">
      <Modal
        show={isFullImageShown}
        onHide={() => onFullImageToggle(false)}
        dialogClassName="umo-grid-item__fullscreen-overlay"
        backdropClassName="umo-grid-item__fullscreen-backdrop"
        style={{ opacity: 1 }}
      >
        <div
          className="umo-grid-item__fullscreen-image"
          onClick={() => onFullImageToggle(false)}
        >
          <span
            onClick={() => onFullImageToggle(false)}
            className="umo-grid-item__fullscreen-image-close-icon"
            aria-label="Close"
          />
          {img}
          <span
            onClick={() => onFullImageToggle(false)}
            className="umo-grid-item__fullscreen-image-fullscreen-button"
          />
        </div>
      </Modal>
    </div>
  );
}

UMODetailViewFullImage.propTypes = {
  isFullImageShown: PropTypes.bool,
  onFullImageToggle: PropTypes.func,
  umoData: PropTypes.instanceOf(Object),
};

export default UMODetailViewFullImage;



// WEBPACK FOOTER //
// ./src/js/components/UMODetailView/UMODetailViewFullImage.jsx